import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap'

const COUNTER_NOTES = {
  requestor: 'Counter All Team / New Request menghitung request Dispatched yang masih memiliki item belum diterima. Owner/admin melihat seluruh requestor; pengguna lain hanya miliknya. Buka request untuk mengingatkan pemohon atau konfirmasi Receive sesuai akses.',
  outbound: 'Counter Outbound Team menghitung request Requested yang masih memiliki item Pending. Proses picking dan dispatch barang ke pemohon.',
  inbound: 'Counter Inbound Team menghitung request Ongoing yang perlu ditindaklanjuti. Saat barang dikembalikan, lakukan Receive Items lalu Put Away.'
}

const InternalRequestStatusHint = ({ audience }) => (
  <Alert color='info'>
    <ul className='mb-0 pl-4'>
      <li><strong>Requested:</strong> permintaan tersimpan; menunggu Outbound melakukan picking dan dispatch.</li>
      <li><strong>Dispatched:</strong> barang sudah dikirim Outbound; pemohon perlu menerima dan mengonfirmasi barang.</li>
      <li><strong>Ongoing:</strong> barang sudah diterima pemohon dan sedang dipinjam / digunakan; kembalikan setelah selesai.</li>
      <li><strong>Marked for Return:</strong> item ditandai untuk dikembalikan; belum berarti barang diterima Inbound.</li>
      <li><strong>Partially Returned:</strong> sebagian barang sudah dikembalikan; masih ada barang yang belum selesai dikembalikan.</li>
      <li><strong>Returned:</strong> barang sudah diterima kembali; Inbound perlu menyelesaikan Put Away.</li>
      <li><strong>Completed:</strong> proses request sudah selesai.</li>
      <li><strong>Cancelled:</strong> permintaan dibatalkan; tidak diproses lebih lanjut.</li>
      <li><strong>Mark as Return:</strong> tandai item yang akan dikembalikan, lalu serahkan barang ke Inbound untuk Receive Items dan Put Away. Menandai item saja belum menyelesaikan pengembalian.</li>
    </ul>
    <div className='mt-2'><strong>Counter notif di menu:</strong> { COUNTER_NOTES[audience] } Satu request dihitung satu kali; bukan jumlah item atau jumlah baris pada halaman ini.</div>
  </Alert>
)

InternalRequestStatusHint.propTypes = {
  audience: PropTypes.oneOf([ 'requestor', 'outbound', 'inbound' ]).isRequired
}

export default InternalRequestStatusHint
